import React, { useEffect, useState } from 'react';
import M_NOT_BASIC_01 from './M_NOT_BASIC_01';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useDelete1, useSearch1, useSearch2 } from './M_NOT_BASIC_01_Query';
import { useDelete } from '../../../Hooks/useDelete';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import Global from '../../../Services/Common/Global';
import Commons from '../../../Services/Common/Common';
import { useBackStack } from '../../../Hooks/back/useBackStack';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { HomeInfoActions } from '../../../Reducer/HomeInfoReducer';

export default function M_NOT_BASIC_01F() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { id } = useParams();
  const [rowData1, setRowData1] = useState(null); // 공지사항 상세 데이터
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [fileList, setFileList] = useState([]); // 첨부파일 목록

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('공지 사항'));
    dispatch(CommonActions.setActiveStep(1));
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      Search1({ ChaebunNo: id });
      Search2({ ChaebunNo: id });
    }
  }, [id, userInfo]);

  // 구분 상세 조회(_value1:"구분값",_value2:로그인정보 , _value3:공지사항 데이터)
  const markNoticeAsRead = (chaebunNo) => {
    if (!chaebunNo) return;
    dispatch(HomeInfoActions.markNoticeRead(chaebunNo));
    queryClient.invalidateQueries({ queryKey: ['Home', 'getHomeData'] });
  };

  const { run: Search1 } = useSearch1({
    onSuccess: (rows) => {
      const row = rows[0];
      setRowData1(row);
      if (row?.chaebunNo) {
        markNoticeAsRead(row.chaebunNo);
      }
    },
  });

  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      const fileListData = rows.map((f) => ({
        ...f,
        preview: /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
          ? `${Global.file.useUrl}files/${f.filePath}`
          : null,
        deleted: false,
      }));

      setFileList(fileListData);
    },
  });

  // 파일 다운로드
  const DownloadLogic2 = async (_data) => {
    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = Commons.EncodeUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //삭제버튼 클릭 시 함수
  const { runAsync: Delete1Async } = useDelete1();

  const { run: Delete1 } = useDelete({
    menuId: 'M_NOT_BASIC_01',
    requestDelete: () => Delete1Async([{ ChaebunNo: id }]),
    onSuccess: () => {
      navigate('/M_Notice');
    },
  });

  return (
    <div>
      <M_NOT_BASIC_01
        rowData1={rowData1}
        Delete1={Delete1}
        fileList={fileList}
        DownloadLogic2={DownloadLogic2}
      />
    </div>
  );
}
